import { CouponType } from 'types/coupon'

export const CONFIRM_COUPON = 'CONFIRM_COUPON'
export const confirmCouponAction = (coupon: CouponType) => {
  return {
    type: 'CONFIRM_COUPON',
    payload: coupon,
  }
}

export const FETCH_COUPONS = 'FETCH_COUPONS'
export const fetchCouponsAction = (coupons: CouponType[]) => {
  return {
    type: 'FETCH_COUPONS',
    payload: coupons,
  }
}

export const INIT_COUPONS = 'INIT_COUPONS'
export const initCouponsAction = () => {
  return {
    type: 'INIT_COUPONS',
    payload: null,
  }
}
